// Persistance locale des couleurs de labels manuels (Jalons).
// La couleur appartient au NOM du label : tous les labels manuels portant le même
// nom partagent la même couleur. Le backend ne stocke pas cette couleur — on la garde
// donc côté navigateur (localStorage), indexée par nom, et on la réinjecte au
// chargement (mapApiLabel) comme au rendu (buildEventTraces).
const KEY = 'leg_label_colors';

// Même normalisation que le regroupement de légende (buildEventTraces) : trim, sensible
// à la casse — pour que la clé de couleur corresponde exactement au groupe affiché.
const norm = (name) => String(name ?? '').trim();

const readAll = () => {
  try {
    return JSON.parse(window.localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

const writeAll = (map) => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    /* quota dépassé / mode privé — on ignore silencieusement */
  }
};

export const getLabelColor = (name) => {
  const k = norm(name);
  return k ? readAll()[k] ?? null : null;
};

export const setLabelColor = (name, color) => {
  const k = norm(name);
  if (!k) return;
  const map = readAll();
  if (color) map[k] = color;
  else delete map[k];
  writeAll(map);
};
